import api from './api';

export interface StartSignupResponse {
  state: string;
  appId: string;
  configId: string;
  graphVersion: string;
}

export interface CompleteSignupPayload {
  code: string;
  state: string;
  wabaId?: string;
  phoneNumberId?: string;
  businessId?: string;
  redirectUri?: string;
}

export interface WhatsAppStatusResponse {
  connected: boolean;
  account: {
    id: string;
    wabaId: string;
    phoneNumberId: string;
    displayPhoneNumber: string | null;
    status: string;
    qualityRating: string | null;
    messagingLimitTier: string | null;
    nameStatus: string | null;
    lastSyncedAt: string | null;
    channelInstanceId: string | null;
    hasPaymentMethod?: boolean;
    currency?: string | null;
    isOnBizApp?: boolean;
    phoneStatus?: string | null;
    channelType?: string;
    provider?: string;
  } | null;
}

export const startWhatsAppEmbeddedSignup = async (): Promise<StartSignupResponse> => {
  const { data } = await api.post('/api/channels/whatsapp/embedded-signup/start');
  return data.data;
};

export const completeWhatsAppEmbeddedSignup = async (payload: CompleteSignupPayload): Promise<any> => {
  const { data } = await api.post('/api/channels/whatsapp/embedded-signup/complete', payload);
  return data.data;
};

export const getWhatsAppAccountStatus = async (options?: { refresh?: boolean }): Promise<WhatsAppStatusResponse> => {
  const query = options?.refresh ? '?refresh=true' : '';
  const { data } = await api.get(`/api/channels/whatsapp/status${query}`);
  return data.data;
};

export const disconnectWhatsAppAccount = async (): Promise<{ success: boolean; disconnected: boolean }> => {
  const { data } = await api.delete('/api/channels/whatsapp');
  return data;
};
